import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  FormLabel,
  TextInput,
  RadioButtonGroup,
  RadioButton,
  Button,
  InlineLoading,
  Tile,
  FormGroup,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  TableCell,
  TextArea,
  ComboBox,
  MultiSelect,
} from 'carbon-components-react';
import View16 from '@carbon/icons-react/lib/view/16';
import Save16 from '@carbon/icons-react/lib/save/16';
import Delete16 from '@carbon/icons-react/lib/delete/16';
import Close16 from '@carbon/icons-react/lib/close/16';
import SimpleReactValidator from 'simple-react-validator';
import moment from 'moment';
import { v4 as uuid } from 'uuid';
import { showNotification } from '../../../../helpers/notification/BaseNotification';
import { getError, apioperation, entitiesLabels, sizeFormat } from '../../../../helpers/Constants';
import FileUpload from '../../../common/FileUpload';
import { NoRecordsPlaceholder } from '../../../../helpers/jsonschemaform/DataTableExtention';
import DownLoadButton from '../../../common/FileDownloadButton';
import { Online, Offline } from '../../../common/OnLineOffLine';
import Timeline from './common/Timeline';
import NewElementTimelineModal from './NewElementTimelineModal';
import DeleteElementTimelineModal from './common/DeleteElementTimelineModal';

export class DrillReportDetail extends Component {
  // reportDetail = {
  //    id: null,
  //    idDrillEmergencyLevel: null,
  //    idUnitsInvolved: null,
  //    idLightCondition: null,
  //    idSeaCondition: null,
  //    idWeatherCondition: null,
  //    lcuReference: null,
  //    temperature: null,
  //    windSpeed: null,
  //    equipmentUsed: null,
  //    poB_BOS: null,
  //    pointsOfStrength: null,
  //    notes: null,
  //    overallAssessmentNote: null,
  //    isSatisfactory: null,
  //    scenarioDescription: null,
  //    referenceProcedure: null,

  //    drillEmergencyLevel: null,
  //    weatherCondition: null,
  //    seaCondition: null,
  //    lightCondition: null,
  //    unitsInvolved: null
  // };

  constructor(props) {
    super(props);

    this.state = {
      drillReport: this.props.drillReport,
      // drillReport: {
      //   ...this.props.drillReport,
      //   unitsInvolved:
      //     this.props.drillReport.unitsInvolved == undefined
      //       ? []
      //       : this.props.drillReport.unitsInvolved,
      // },
      modalDeleteAttachmentVisible: false,
      modalNewElementTimelineVisible: false,
      modalDeleteElementTimelineVisible: false,
      selectedElementTimeline: null,
      selectedAttachment: null,
      filterunitsInvolved: [],
      flagItemsUI: false,
    };
    this.updateParent1 = null;
    console.log("DrillReportDetail.costructor: genNotesStrengthPoints: " + this.props?.drillReport?.genNotesStrengthPoints);
    this.handleDeleteAttachmentModalVisibility = this.handleDeleteAttachmentModalVisibility.bind(
      this
    );
    this.handleNewElementTimelineVisibility = this.handleNewElementTimelineVisibility.bind(this);
    this.onElementTimelineSubmit = this.onElementTimelineSubmit.bind(this);
    this.handleDeleteElementTimelineVisibility = 
      this.handleDeleteElementTimelineVisibility.bind(this);
    this.onElementTimelineDelete = this.onElementTimelineDelete.bind(this);
    this.showDeleteAttachmentModal = this.showDeleteAttachmentModal.bind(this);
    this.deleteAttachment = this.deleteAttachment.bind(this);

    this.updateReportDetail = this.updateReportDetail.bind(this);

    this.validator = new SimpleReactValidator();
    this.getRadioButtonLight = this.getRadioButtonLight.bind(this);
    this.getRadioButtonSea = this.getRadioButtonSea.bind(this);
    this.getRadioButtonWeather = this.getRadioButtonWeather.bind(this);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.drillReport !== this.props.drillReport) {
      this.setState(() => {
        const drillRep = { ...nextProps.drillReport };
        if (nextProps.drillReport?.drillPlan?.newEmergLevManagement) {
          //RITM0995432 - EM Drill Report Detail Tab Issue Fix
          //drillRep.unitsInvolved = []; 
          const filterUnitsInv = this.getFilterUnitsInvolved(nextProps.unitsInvolved, nextProps.drillReport?.drillPlan?.drillEmergencyLevel);
          let filterUnitsInvId = filterUnitsInv.map((item) => { return item.id; });
          drillRep.unitsInvolved = drillRep.unitsInvolved.filter((item) => filterUnitsInvId.includes(item.id));
          //console.log(drillRep.unitsInvolved);
          return { drillReport: drillRep, 
                   filterunitsInvolved: filterUnitsInv
                    // this.getFilterUnitsInvolved(nextProps.unitsInvolved, 
                    //   nextProps.drillReport?.drillPlan?.drillEmergencyLevel) 
                };
          //End
        }
        console.log("DrillReportDetail.componentWillReceiveProps: genNotesStrengthPoints: " + nextProps.drillReport?.genNotesStrengthPoints);
        return { drillReport: drillRep };
      });
    }
  }

  // **************** TIMELINE **************** START

  onElementTimelineSubmit(updatedTimeline) {
    if (updatedTimeline !== null) {
      this.setState((prevState) => {
        const drillReport = { ...prevState.drillReport };
        const selectedElementTimeline = { ...prevState.selectedElementTimeline };
        selectedElementTimeline.timeFrom = updatedTimeline.timeFrom;
        selectedElementTimeline.activityDescription = updatedTimeline.activityDescription;
        selectedElementTimeline.remarks = updatedTimeline.remarks;
        if (!selectedElementTimeline.id) {
          selectedElementTimeline.id = uuid();
          selectedElementTimeline.idDrillReports = drillReport.id;
          drillReport.timelines = prevState.drillReport.timelines.concat([selectedElementTimeline]);
        } else {
          drillReport.timelines = prevState.drillReport.timelines
            .filter((item) => selectedElementTimeline.id !== item.id)
            .concat([selectedElementTimeline]);
        }
        return { drillReport };
      });
      this.handleNewElementTimelineVisibility(null);
    }
  }

  // saveDrillReport = () => {
  //   this.props.onDetailsChanged(this.state.drillReport);
  // };
  
  onElementTimelineDelete() {
    this.setState((prevState) => {
      const drillReport = { ...prevState.drillReport };
      const selectedElementTimeline = { ...prevState.selectedElementTimeline };
      drillReport.timelines = prevState.drillReport.timelines.filter(
        (item) => selectedElementTimeline.id !== item.id
      );
      return { drillReport };
    });
    this.handleDeleteElementTimelineVisibility(null);
  }
  // **************** TIMELINE **************** END

  getFilterUnitsInvolved(unitsInvolved, drillEmergencyLevel) {
    let filter = [];
    if (drillEmergencyLevel.name.includes('3') || drillEmergencyLevel.name.includes('2')) {
      filter = unitsInvolved.filter(
        (x) =>
          x.name.includes('Saipem Milan Crisis Unit') ||
          x.name.includes('Local Crisis unit') ||
          x.name.includes('Division Manager') ||
          x.name.includes('Duty Manager')
      );
    } else {
      filter = this.props.unitsInvolved;
    }
    return filter;
  }

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  updateStateInvolved = (inputName, inputValue) => {
    if (inputValue) {
      const filter = this.getFilterUnitsInvolved(this.props.unitsInvolved, inputValue);

      const statusCopy = { ...this.state };
      statusCopy.drillReport.unitsInvolved = [];
      statusCopy.filterunitsInvolved = filter;

      this.setState(statusCopy);
    } else {
      const statusCopy = { ...this.state };
      statusCopy.drillReport.unitsInvolved = [];
      statusCopy.filterunitsInvolved = [];
      this.setState(statusCopy);
    }
  };

  getRadioButtonLight = () => {
    const lightConditions = this.props?.lightCondition;

    return lightConditions.map((item) => (
      <RadioButton
        id={`${item.name}id`}
        key={`${item.name}key`}
        name={item.name}
        value={item.id}
        labelText={item.name}
        alt="drillReport"
        disabled={this.props.editingDisabled}
        onClick={() => this.onreadystatechangeL(item.id)}
      />
    ));
  };

  getRadioButtonSea = () => {
    const seaConditions = this.props?.seaCondition;

    return seaConditions.map((item) => (
      <RadioButton
        id={`${item.name}id`}
        key={`${item.name}_key`}
        name={item.name}
        value={item.id}
        labelText={item.name}
        alt="drillReport"
        disabled={this.props.editingDisabled}
        onClick={() => this.onreadystatechangeS(item.id)}
      />
    ));
  };

  getRadioButtonWeather = () => {
    const weatherConditions = this.props?.weatherCondition;
    return weatherConditions.map((item) => (
      <RadioButton
        id={`${item.name}id`}
        key={`${item.name}__key`}
        name={item.name}
        value={item.id}
        labelText={item.name}
        alt="drillReport"
        disabled={this.props.editingDisabled}
        onClick={() => this.onreadystatechangeW(item.id)}
      />
    ));
  };

  onreadystatechangeL = (id) => {
    const statusCopy = { ...this.state };
    // const light = this.state.drillReport?.idLightCondition
    //   ? this.state.drillReport?.idLightCondition === id
    //     ? 1
    //     : 2
    //   : 0;
    let light = 0;
    if (this.state.drillReport?.idLightCondition) {
      if (this.state.drillReport?.idLightCondition === id) { light = 1; } else { light = 2; }
    }
    if (light === 0 || light === 2) {
      statusCopy.drillReport.idLightCondition = id;
    }
    if (light === 1) {
      statusCopy.drillReport.idLightCondition = null;
    }
    this.setState(statusCopy);
  };

  onreadystatechangeS = (id) => {
    const statusCopy = { ...this.state };
    // const sea = this.state.drillReport?.idSeaCondition
    //   ? this.state.drillReport?.idSeaCondition === id
    //     ? 1
    //     : 2
    //   : 0;
    let sea = 0;
    if (this.state.drillReport?.idSeaCondition) {
      if (this.state.drillReport?.idSeaCondition === id) { sea = 1; } else { sea = 2; }
    }
    if (sea === 0 || sea === 2) {
      statusCopy.drillReport.idSeaCondition = id;
    }
    if (sea === 1) {
      statusCopy.drillReport.idSeaCondition = null;
    }
    this.setState(statusCopy);
  };

  onreadystatechangeW = (id) => {
    const statusCopy = { ...this.state };
    // const weather = this.state.drillReport?.idWeatherCondition
    //   ? this.state.drillReport?.idWeatherCondition === id
    //     ? 1
    //     : 2
    //   : 0;
    let weather = 0;
    if (this.state.drillReport?.idWeatherCondition) {
      if (this.state.drillReport?.idWeatherCondition === id) { weather = 1; } else { weather = 2; }
    }

    if (weather === 0 || weather === 2) {
      statusCopy.drillReport.idWeatherCondition = id;
    }
    if (weather === 1) {
      statusCopy.drillReport.idWeatherCondition = null;
    }
    this.setState(statusCopy);
  };

  handleChangeRadio = (value, id, event) => {
    let v = null;
    if (value === 'true') {
      v = true;
    } else if (value === 'false') {
      v = false;
    } else if (value === 'null') {
      v = null;
    }
    this.updateState(event.target.name, v, event.target.alt);
  };

   // **************** TIMELINE **************** START
   handleNewElementTimelineVisibility(id) {
    const timeline = this.state.drillReport.timelines.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalNewElementTimelineVisible: !oldState.modalNewElementTimelineVisible,
      selectedElementTimeline: timeline || {},
    }));
  }

  handleDeleteElementTimelineVisibility(id) {
    const timeline = this.state.drillReport.timelines.find((i) => i.id === id);
    this.setState((oldState) => ({
      modalDeleteElementTimelineVisible: !oldState.modalDeleteElementTimelineVisible,
      selectedElementTimeline: timeline || {},
    }));
  }
  // **************** TIMELINE **************** END

  updateParent() {
    this.updateParent1();
  }

  updateReportDetail() {
    if (this.validator.allValid()) {
      this.props.updateReportDetail(this.state.drillReport);
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.EMERGENCYDRILL} required fields are missing  `
      );
      this.forceUpdate();
    }
  }

    // *************** ATTACHMENT *************** START
    handleDeleteAttachmentModalVisibility() {
      this.setState((oldState) => ({
        modalDeleteAttachmentVisible: !oldState.modalDeleteAttachmentVisible,
        selectedAttachment: null,
      }));
    }
  
    showDeleteAttachmentModal(Id) {
      const selectedItem = this.props.drillReport.attachments.find((item) => 
        item.idAttachment === Id);
      this.setState((oldState) => ({
        selectedAttachment: selectedItem,
        modalDeleteAttachmentVisible: !oldState.modalDeleteAttachmentVisible,
      }));
    }
  
    deleteAttachment() {
      this.props.deleteAttachment(this.state.selectedAttachment.idAttachment);
      this.handleDeleteAttachmentModalVisibility();
    }
  
    renderDeleteAttachmentModal = () =>
      this.state.modalDeleteAttachmentVisible && (
        <div className="bx--modal bx--modal-tall is-visible">
          <div className="bx--modal-container">
            <div className="bx--modal-header">
              <h3 className="bx--modal-header__heading">Delete Attachment</h3>
              <Button
                className="bx--modal-close"
                renderIcon={Close16}
                onClick={this.handleDeleteAttachmentModalVisibility}
              />
            </div>
  
            <div className="bx--modal-content">
              <div className="bx--row bx--modal-content-detail">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <h5 className="align-center">
                    {`Press confirm to delete ${this.state.selectedAttachment?.attachment.name}`}
                  </h5>
                </div>
              </div>
            </div>
            <div className="bx--modal-footer">
              <Button
                className="button--max-width"
                kind="secondary"
                onClick={this.handleDeleteAttachmentModalVisibility}
              >
                Cancel
              </Button>
              <Button className="button--max-width" kind="primary" onClick={this.deleteAttachment}>
                Confirm
              </Button>
            </div>
          </div>
        </div>
      );
    // *************** ATTACHMENT *************** END

  isLcuReferenceMandatory() {
    return (
      this.state.drillReport.drillEmergencyLevel?.name === '2' ||
      this.state.drillReport.drillEmergencyLevel?.name === '3' ||
      this.state.drillReport.drillEmergencyLevel?.name === 'Crisis'
    );
  }

  renderTab = () => {
    let ui = true;
    if (this.state.drillReport != null) {
      ui = (this.state.drillReport !== undefined &&
        this.state.drillReport.unitsInvolved !== undefined &&
        this.state.drillReport.unitsInvolved.length > 0);
    }

    const validations = {
      idEmergencyLevel: this.validator.message(
        'emergencyLevel',
        this.state.drillReport.idEmergencyLevel,
        'required'
      ),
      lcuReference: this.validator.message(
        'lcuReference',
        this.isLcuReferenceMandatory() ? this.state.drillReport.lcuReference : true,
        'required'
      ),
      unitsInvolved: this.validator.message(
        'unitsInvolved',
        ui,
        'accepted'
      ),
      scenarioDescription: this.validator.message(
        'scenarioDescription',
        this.state.drillReport.scenarioDescription,
        'required'
      ),
      referenceProcedure: this.validator.message(
        'referenceProcedure',
        this.state.drillReport.referenceProcedure,
        'required'
      ),
      notes: this.validator.message(
        'notes',
        this.state.drillReport.overallAssessmentNotes,
        'required'
      ),
      equipmentUsed: this.validator.message(
        'equipmentUsed',
        this.state.drillReport.equipmentUsed,
        'required'
      ),
      isSatisfactory: this.validator.message(
        'isSatisfactory',
        this.state.drillReport.isSatisfactory,
        'required'
      ),
      /* RITM0822996 */
      needsToRepeat: this.validator.message(
        'needsToRepeat',
        this.state.drillReport.needsToRepeat,
        'required'
      ),
      timelines: this.validator.message(
        'timelines',
        this.state.drillReport?.timelines ? 
          (this.state.drillReport.timelines[0] && this.state.drillReport.timelines[1]) : true,
        'required'
      ),
    };

    const selectedItemCombo = {
      unitinv: (this.state.drillReport?.unitsInvolved || []).map((elem) => elem.name).join(', '),
    };

    const TempScale = this.state.drillReport.temperatureScale;
    const timelineHead = [{ key: 'timeFrom', header: 'Time From' }, { key: 'activityDescription', header: 'Activity Description' }, { key: 'remarks', header: 'Remarks' }];
    const timelinesSorted = this.state.drillReport.timelines?.sort((a, b) => {
      const dateA = new Date('2000-01-01T00:00:00');
      const dateB = new Date('2000-01-01T00:00:00');
      const hA = moment(a.timeFrom, 'HH:mm a');
      const hB = moment(b.timeFrom, 'HH:mm a');
      dateA.setHours(hA.hours(), hA.minutes());
      dateB.setHours(hB.hours(), hB.minutes());
      return dateA - dateB;
    });
    return (
      <>
        {this.renderDeleteAttachmentModal()}
        <div className="bx--row">
          <div className="bx--col-lg-12 bx--col-md-12">
            <Tile className="bx--tile bx--tile--light">
              <div className="bx--row section--title">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">Main Details</h3>
                </div>
              </div>
              <div className="bx--row section--title bx--fieldset">
                <div className="bx--col-lg-6 bx--col-md-12">
                  <FormLabel className="some-class">Emergency Level *</FormLabel>
                  {/* <Combo
                    url="drill/emergencylevel"
                    // invalid={validations.drillEmergencyLevel != null}
                    // invalidText={validations.drillEmergencyLevel}
                    onChange={(el) => {
                      this.updateState(
                        'idEmergencyLevel',
                        el.selectedItem?.id || null,
                        'drillReport'
                      );
                      this.updateState(
                        'drillEmergencyLevel',
                        el.selectedItem || null,
                        'drillReport'
                      );
                      this.updateState('unitsInvolved', [], 'drillReport');
                    }}
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.DRILLEMERGENCYLEVEL, apioperation.GET)
                      );
                    }}
                    key="this.state.drillReport?.drillEmergencyLevel?.id"
                    initialSelectedItems={this.state.drillReport?.drillEmergencyLevel}
                    disabled={this.props.editingDisabled}
                    entity={this.state.drillReport?.drillEmergencyLevel?.id}
                    invalid={validations.idEmergencyLevel != null}
                    placeholder="Select"
                  /> */}
                  <ComboBox
                    id={`combo_${this.state.drillReport?.id}`}
                    key={`drillReport_${this.state.drillReport?.id}`}
                    placeholder="Select"
                    name="drillEmergencyLevel"
                    alt="drillReport"
                    onChange={(el) => {
                      this.updateState(
                        'idEmergencyLevel',
                        el.selectedItem?.id || null,
                        'drillReport'
                      );
                      this.updateState(
                        'drillEmergencyLevel',
                        el.selectedItem || null,
                        'drillReport'
                      );
                      this.updateStateInvolved('unitsInvolved', el.selectedItem);
                    }}
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.DRILLEMERGENCYLEVEL, apioperation.GET)
                      );
                    }}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={
                      this.state.drillReport?.drillEmergencyLevel
                        ? this.state.drillReport?.drillEmergencyLevel
                        : []
                    }
                    items={this.props.emergencylevel}
                    disabled={this.props.editingDisabled || 
                              this.props.drillReport?.drillPlan?.newEmergLevManagement}
                    invalid={validations.idEmergencyLevel != null}
                  />
                  {validations.idEmergencyLevel}
                </div>
                <div className="bx--col-lg-6 bx--col-md-12">
                  <FormLabel className="some-class">
                    Involved LCU
                    {this.isLcuReferenceMandatory() ? '*' : ''}
                  </FormLabel>
                  <TextInput
                    id="lcuReference"
                    name="lcuReference"
                    placeholder="Involved LCU"
                    value={this.state.drillReport?.lcuReference}
                    onChange={(el) =>
                      this.updateState('lcuReference', el.target.value, 'drillReport')
                    }
                    type="text"
                    labelText=""
                    invalid={validations.lcuReference != null}
                    disabled={this.props.editingDisabled}
                  />
                  {validations.lcuReference}
                </div>
              </div>
              <React.StrictMode>
                <Timeline timelineHeader={timelineHead} dataRows={timelinesSorted || []} timelineTblTitle="Timeline*" editingDisabled={this.props.editingDisabled} validationTimelines={validations.timelines} handleNewElementModal={this.handleNewElementTimelineVisibility} handleDeleteElementModal={this.handleDeleteElementTimelineVisibility} />
                <NewElementTimelineModal 
                  modalNewElementVisible={this.state.modalNewElementTimelineVisible} 
                  handleNewElementModal={this.handleNewElementTimelineVisibility} 
                  selectedTimeline={this.state.selectedElementTimeline} 
                  editingDisabled={this.props.editingDisabled} 
                  onSubmitElementTimeline={this.onElementTimelineSubmit} 
                />
                <DeleteElementTimelineModal 
                  modalDeleteVisible={this.state.modalDeleteElementTimelineVisible} 
                  modalTitle="Delete Activity" 
                  confirmationMessage="Press confirm to remove selected activity" 
                  handleDeleteModal={this.handleDeleteElementTimelineVisibility} 
                  onElementDelete={this.onElementTimelineDelete} 
                />
              </React.StrictMode>
              <div className="bx--row bx--fieldset">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Scenario Description*">
                    <TextArea
                      maxLength={5000}
                      id="scenarioDescription"
                      placeholder="Input scenario description"
                      value={this.state.drillReport?.scenarioDescription || ''}
                      onChange={(el) =>
                        this.updateState('scenarioDescription', el.target.value, 'drillReport')
                      }
                      hideLabel
                      labelText=""
                      light
                      rows={4}
                      cols={230}
                      disabled={this.props.editingDisabled}
                      invalid={validations.scenarioDescription != null}
                    />
                  </FormGroup>
                  {validations.scenarioDescription}
                </div>
              </div>
              <div className="bx--row bx--fieldset">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Reference Procedure*">
                    <TextArea
                      maxLength={5000}
                      id="referenceProcedure"
                      placeholder="Input reference procedure"
                      value={this.state.drillReport?.referenceProcedure || ''}
                      onChange={(el) =>
                        this.updateState('referenceProcedure', el.target.value, 'drillReport')
                      }
                      hideLabel
                      labelText=""
                      light
                      rows={4}
                      cols={230}
                      disabled={this.props.editingDisabled}
                      invalid={validations.referenceProcedure != null}
                    />
                  </FormGroup>
                  {validations.referenceProcedure}
                </div>
              </div>
              <div className="bx--row bx--fieldset">
                <div className="bx--col-lg-6 bx--col-md-12">
                  <FormLabel className="some-class">Units Involved *</FormLabel>
                  {/* <Combo
                    url={`drill/unitsInvolved/${this.state.drillReport.drillEmergencyLevel?.name}`}
                    // invalid={validations.drillEmergencyLevel != null}
                    // invalidText={validations.drillEmergencyLevel}
                    onChange={(units) => this.updateState('unitsInvolved', units, 'drillReport')}
                    multiCombo
                    onError={(error) => {
                      showNotification.error(
                        getError(error, entitiesLabels.UNITSINVOLVED, apioperation.GET)
                      );
                    }}
                    key="this.state.drillReport?.unitsInvolved?.id"
                    initialSelectedItems={this.state.drillReport?.unitsInvolved}
                    disabled={this.props.editingDisabled}
                    invalid={validations.unitsInvolved != null}
                    placeholder="Select"
                  /> */}
                  <MultiSelect
                    id={`multiSelect_${this.state.drillReport?.id}`}
                    key={`unitsInvolved_${this.state.drillReport?.idEmergencyLevel}`}
                    label={
                      selectedItemCombo.unitinv
                        ? selectedItemCombo.unitinv
                        : 'Choose one or more items'
                    }
                    multiCombo
                    name="unitsInvolved"
                    alt="drillReport"
                    onChange={(units) =>
                      this.updateState('unitsInvolved', units.selectedItems, 'drillReport')
                    }
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItems={
                      selectedItemCombo.unitinv ? this.state.drillReport?.unitsInvolved : []
                    }
                    items={this.state.filterunitsInvolved}
                    invalid={validations.unitsInvolved != null}
                    onError={(error) => {
                      showNotification.error(
                        `${entitiesLabels.ERROR}`,
                        getError(error, entitiesLabels.UNITSINVOLVED, apioperation.GET)
                      );
                    }}
                    disabled={this.state.filterunitsInvolved.length === 0}
                  >
                    {' '}
                  </MultiSelect>
                </div>
                <div className="bx--col-lg-6 bx--col-md-12">
                  <FormLabel className="some-class">POB/POS</FormLabel>
                  <TextInput
                    id="poB_BOS"
                    name="poB_BOS"
                    placeholder="Input POB/POS"
                    value={this.state.drillReport?.poB_BOS}
                    onChange={(el) => this.updateState('poB_BOS', el.target.value, 'drillReport')}
                    disabled={this.props.editingDisabled}
                    type="number"
                    labelText=""
                  />
                </div>
              </div>
              <div className="bx--row bx--fieldset">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Equipment Used*">
                    <TextArea
                      maxLength={5000}
                      id="equipmentUsed"
                      placeholder="Input equipment used"
                      value={this.state.drillReport?.equipmentUsed || ''}
                      onChange={(el) =>
                        this.updateState('equipmentUsed', el.target.value, 'drillReport')
                      }
                      hideLabel
                      labelText=""
                      light
                      rows={4}
                      cols={230}
                      disabled={this.props.editingDisabled}
                      invalid={validations.equipmentUsed != null}
                    />
                  </FormGroup>
                  {validations.equipmentUsed}
                </div>
              </div>
            </Tile>
            <Tile className="bx--tile bx--tile--light">
              <div className="bx--row section--title">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">Weather Conditions</h3>
                </div>
              </div>
              <div className="bx--row section--title">
                <div className="bx--col-lg-3 bx--col-md-3  ">
                  <FormGroup legendText="Light">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="idLightCondition"
                      // onChange={this.handleChangeRadio}
                      orientation="vertical"
                      valueSelected={this.state.drillReport?.idLightCondition}
                      disabled={this.props.editingDisabled}
                    >
                      {this.getRadioButtonLight()}
                    </RadioButtonGroup>
                  </FormGroup>
                </div>
                <div className="bx--col-lg-3 bx--col-md-3">
                  <FormGroup legendText="Sea">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="idSeaCondition"
                      // onChange={this.handleChangeRadio}
                      orientation="vertical"
                      valueSelected={this.state.drillReport?.idSeaCondition}
                      disabled={this.props.editingDisabled}
                    >
                      {this.getRadioButtonSea()}
                    </RadioButtonGroup>
                  </FormGroup>
                </div>
                <div className="bx--col-lg-3 bx--col-md-3">
                  <FormGroup legendText="Weather">
                    <RadioButtonGroup
                      labelPosition="right"
                      legend=""
                      name="idWeatherCondition"
                      // onChange={this.handleChangeRadio}
                      orientation="vertical"
                      valueSelected={this.state.drillReport?.idWeatherCondition}
                      disabled={this.props.editingDisabled}
                    >
                      {this.getRadioButtonWeather()}
                    </RadioButtonGroup>
                  </FormGroup>
                </div>
                <div className="bx--col-lg-3 bx--col-md-3  ">
                  <FormGroup legendText={`Temperature (°${TempScale})`}>
                    {TempScale === 'C' && <p style={{ color: 'darkorange' }}>Note: insert the Temperature in °C scale</p>}
                    <TextInput
                      // invalid={validations.poB_BOS != null}
                      // invalidText={validations.poB_BOS}
                      id="temperature"
                      name="temperature"
                      placeholder="Input Temperature"
                      value={this.state.drillReport?.temperature}
                      onChange={(el) =>
                        this.updateState('temperature', el.target.value, 'drillReport')
                      }
                      type="number"
                      labelText=""
                      // invalid={validations.temperature != null}
                      disabled={this.props.editingDisabled}
                    />
                    {/* {validations.temperature} */}
                  </FormGroup>
                  <FormGroup legendText="Wind Speed (Knot)">
                    <TextInput
                      id="windSpeed"
                      name="windSpeed"
                      placeholder="Input Wind Speed"
                      value={this.state.drillReport?.windSpeed}
                      onChange={(el) =>
                        this.updateState('windSpeed', el.target.value, 'drillReport')
                      }
                      type="number"
                      labelText=""
                      // invalid={validations.windSpeed != null}
                      disabled={this.props.editingDisabled}
                    />
                    {/* {validations.windSpeed} */}
                  </FormGroup>
                </div>
              </div>
            </Tile>
            <Tile className="bx--tile bx--tile--light">
              <div className="bx--row section--title">
                <div>
                  {' '}
                  <h3 className="title--medium--expressive">Overall Assessment</h3>
                </div>
              </div>
              <div className="bx--row section--title">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Notes* (The mention of names and surnames must be done only if strictly necessary)">
                    <TextArea
                      maxLength={5000}
                      id="overallAssessmentNotes"
                      placeholder="Input overall assessment notes"
                      value={this.state.drillReport?.overallAssessmentNotes || ''}
                      onChange={(el) =>
                        this.updateState('overallAssessmentNotes', el.target.value, 'drillReport')
                      }
                      hideLabel
                      labelText=""
                      light
                      rows={4}
                      cols={230}
                      disabled={this.props.editingDisabled}
                      invalid={validations.notes != null}
                    />
                  </FormGroup>
                  {validations.notes}
                </div>
              </div>
              <div className="bx--row bx--fieldset">
                <div className="bx--col-lg-12 bx--col-md-12">
                  {/* <div className="bx--col-lg-2 bx--col-md-2"> */}
                  <RadioButtonGroup
                    labelPosition="right"
                    legend=""
                    name="isSatisfactory"
                    onChange={this.handleChangeRadio}
                    orientation="horizontal"
                    valueSelected={`${this.state.drillReport?.isSatisfactory}`}
                    disabled={this.props.editingDisabled}
                  >
                    <RadioButton
                      id="satisfactory"
                      key="satisfactory"
                      name="isSatisfactory"
                      value="true"
                      labelText="Satisfactory"
                      alt="drillReport"
                      disabled={this.props.editingDisabled}
                    />
                    <RadioButton
                      id="unSatisfactory"
                      key="unSatisfactory"
                      name="isSatisfactory"
                      value="false"
                      labelText="UnSatisfactory"
                      alt="drillReport"
                      disabled={this.props.editingDisabled}
                    />
                  </RadioButtonGroup>
                  {validations.isSatisfactory}
                </div>
              </div>
              <div className="bx--row bx--fieldset">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText={this.state.drillReport?.genNotesStrengthPoints != true
                    ? "General Notes (The mention of names and surnames must be done only if strictly necessary)"
                    : "General Notes (insert here strength points and improvement areas)"
                  }
                  >
                    <TextArea
                      maxLength={5000}
                      id="notes"
                      placeholder="Input notes"
                      value={this.state.drillReport?.notes || ''}
                      onChange={(el) => this.updateState('notes', el.target.value, 'drillReport')}
                      hideLabel
                      labelText=""
                      light
                      rows={4}
                      cols={230}
                      disabled={this.props.editingDisabled}
                    />
                  </FormGroup>
                </div>
              </div>
              <div className="bx--row bx--fieldset">
                 {this.state.drillReport?.genNotesStrengthPoints != true ?
                    (
                    <div className="bx--col-lg-12 bx--col-md-12">
                      <FormGroup legendText="Strength Points">
                        <TextArea
                          maxLength={5000}
                          id="pointsOfStrength"
                          placeholder="Input Strength Points"
                          value={this.state.drillReport?.pointsOfStrength || ''}
                          onChange={(el) =>
                            this.updateState('pointsOfStrength', el.target.value, 'drillReport')
                          }
                          hideLabel
                          labelText=""
                          light
                          rows={4}
                          cols={230}
                          disabled={this.props.editingDisabled}
                          // RITM0580253
                          // invalid={validations.pointsOfStrength != null}
                        />
                      </FormGroup>
                      {/* RITM0580253 */}
                      {/* {validations.pointsOfStrength} */}
                    </div>
                    ) : ('')
                 }
              </div>
              <div className="bx--row bx--fieldset">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <FormGroup legendText="Needs to Repeat the Emergency Drill*">
                    {/* RITM0822996 */}
                    <RadioButtonGroup
                      labelPosition="right"
                      legendText="Needs to Repeat the Emergency Drill*"
                      name="needsToRepeat"
                      onChange={this.handleChangeRadio}
                      orientation="horizontal"
                      valueSelected={`${this.state.drillReport?.needsToRepeat}`}
                      disabled={this.props.editingDisabled}
                    >
                      <RadioButton
                        id="needsToRepeatYES"
                        key="needsToRepeatYES"
                        name="needsToRepeat"
                        value="true"
                        labelText="YES"
                        alt="drillReport"
                        disabled={this.props.editingDisabled}
                      />
                      <RadioButton
                        id="needsToRepeatNO"
                        key="needsToRepeatNO"
                        name="needsToRepeat"
                        value="false"
                        labelText="NO"
                        alt="drillReport"
                        disabled={this.props.editingDisabled}
                      />
                    </RadioButtonGroup>
                  </FormGroup>
                  {validations.needsToRepeat}
                </div>
              </div>
            </Tile>
          </div>
        </div>
        {!this.props.editingDisabled ? (
          <div className="bx--col-lg-12 bx--col-md-12 main-information-button">
            <Button
              size="default"
              renderIcon={Save16}
              kind="primary"
              onClick={this.updateReportDetail}
              disabled={this.props.editingDisabled}
            >
              Save
            </Button>
          </div>
        ) : (
          ''
        )}

        <Tile className="bx--tile bx--tile--light">
          {!this.props.editingDisabled ? (
            <div className="bx--col-lg-6 bx--col-md-6">
              <FileUpload
                Container="saipem"
                StoragePath="drillReport"
                onUpload={this.props.onUpload}
                disabled={this.props.editingDisabled}
              />
              {/*
                    <Online>
                        <FileUpload
                            Container="saipem"
                            StoragePath="drillReport"
                            onUpload={this.onUpload}
                            disabled={this.props.editingDisabled}
                        />
                    </Online>
                    <Offline>
                        <FileUpload
                            Container="saipem"
                            StoragePath="drillReport"
                            onUpload={this.onUpload}
                            disabled
                        />
                    </Offline>
                    */}
            </div>
          ) : (
            ''
          )}
        </Tile>
        <Tile className="bx--tile bx--tile--light">
          <div className="bx--col-lg-12 bx--col-md-12">
            <TableContainer className="bx--grid--full-width">
              <Table>
                <TableHead className="colorgray">
                  <TableRow>
                    <TableHeader>Name</TableHeader>
                    <TableHeader>Size</TableHeader>
                    <TableHeader className="align-center">Actions</TableHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.drillReport?.attachments < 1 ? (
                    <NoRecordsPlaceholder 
                      labelText="No Records" 
                      title="&#9888; It is forbidden to upload photos wich show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people"
                      colSpan={3} 
                    />
                  ) : (
                    this.state.drillReport?.attachments?.map((item) => (
                      <TableRow 
                        key={`row_${item.idAttachment}`}
                        title="&#9888; It is forbidden to upload photos wich show people's faces. It is also forbidden to upload photos on which it is possible to recognize specific people"
                      >
                        <TableCell key={`cell_1_${item.idAttachment}`}>{item.attachment?.name}</TableCell>
                        <TableCell key={`cell_2_${item.idAttachment}`}>
                          {sizeFormat(item.attachment?.size)}
                        </TableCell>
                        <TableCell key={`action-${item.idAttachment}`} className="tableActions align-center">
                          {this.props.downloading === item.idAttachment ? (
                            <div>
                              <InlineLoading
                                description=""
                                iconDescription="downloading.."
                                status="active"
                              />
                            </div>
                          ) : (
                            <div>
                              <Online>
                                <DownLoadButton
                                  onError={(error) => {
                                    showNotification.error(
                                      `${entitiesLabels.ERROR}`,
                                      getError(error, entitiesLabels.FileUpload, apioperation.GET)
                                    );
                                  }}
                                  onDownLoadStart={() =>
                                    this.setState({
                                      downloading: item.idAttachment,
                                    })
                                  }
                                  onDownLoadEnd={() => this.setState({ downloading: null })}
                                  apiUrl={`/drill/report/${this.props.drillReport.id}/attachment/${item?.attachment?.fileIdentifier}`}
                                  fileName={item?.attachment?.name}
                                  size="small"
                                  renderIcon={View16}
                                  iconDescription="Download"
                                  kind="ghost"
                                  disabled={this.props.editingDisabled}
                                />
                              </Online>
                              <Offline>
                                <Button
                                  size="small"
                                  renderIcon={View16}
                                  iconDescription="Download"
                                  kind="ghost"
                                  disabled
                                />
                              </Offline>
                              {/* <Button
                                onClick={() =>
                                  this.props.downloadAttachment(item.id)
                                }
                                size="small"
                                renderIcon={View16}
                                iconDescription="Download"
                                kind="ghost"
                                disabled={this.props.editingDisabled}
                              /> */}
                              <Online>
                                <Button
                                  onClick={() => this.showDeleteAttachmentModal(item.idAttachment)}
                                  size="small"
                                  renderIcon={Delete16}
                                  iconDescription="Delete"
                                  kind="ghost"
                                  disabled={this.props.editingDisabled}
                                />
                              </Online>
                              <Offline>
                                <Button
                                  size="small"
                                  renderIcon={Delete16}
                                  iconDescription="Delete"
                                  kind="ghost"
                                  disabled
                                />
                              </Offline>
                              {/* <Online>
                                    <Button
                                        onClick={() => this.downloadAttachment(item.id)}
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Download"
                                        kind="ghost"
                                        disabled={this.props.editingDisabled}
                                    />
                                    <Button
                                        onClick={() => this.deleteAttachment(item.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                        disabled={this.props.editingDisabled}
                                    />
                                </Online>
                                {/*<Offline>
                                    <Button
                                        onClick={() => this.downloadAttachment(item.id)}
                                        size="small"
                                        renderIcon={View16}
                                        iconDescription="Download"
                                        kind="ghost"
                                        disabled
                                    />
                                    <Button
                                        onClick={() => this.deleteAttachment(item.id)}
                                        size="small"
                                        renderIcon={Delete16}
                                        iconDescription="Delete"
                                        kind="ghost"
                                        disabled
                                    />
                                </Offline> 
                                */}
                            </div>
                          )
                          }
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </Tile>
      </>
    );
  };

  render() {
    console.log("DrillReportDetail.render: genNotesStrengthPoints: " + this.state.drillReport?.genNotesStrengthPoints);
    return this.renderTab();
  }
}

DrillReportDetail.propTypes = {
  deleteAttachment: PropTypes.func.isRequired,
  onUpload: PropTypes.func.isRequired,
  updateReportDetail: PropTypes.func.isRequired, 
  downloading: PropTypes.bool.isRequired,
  drillReport: PropTypes.shape({
    id: PropTypes.string,
    sequence: PropTypes.number,
    drillReportCode: PropTypes.string,
    name: PropTypes.string,
    lcuReference: PropTypes.string,
    scenarioDescription: PropTypes.string,
    overallAssessmentNotes: PropTypes.string,
    isSatisfactory: PropTypes.bool,
    referenceProcedure: PropTypes.string,
    deliveryDate: PropTypes.string,
    isInPlannedWeek: PropTypes.bool,
    deliveryDateWithWeek: PropTypes.string,
    plannedWeekWithDate: PropTypes.string,
    idDrillPlan: PropTypes.string,
    idStatus: PropTypes.number,
    compilerAssignStatus: PropTypes.string,
    idLightCondition: PropTypes.string,
    idSeaCondition: PropTypes.string,
    idWeatherCondition: PropTypes.string,
    idEmergencyLevel: PropTypes.string,
    temperature: PropTypes.number,
    temperatureScale: PropTypes.string,
    windSpeed: PropTypes.number,
    equipmentUsed: PropTypes.string,
    distributionList: PropTypes.string,
    poB_BOS: PropTypes.number,
    pointsOfStrength: PropTypes.string,
    notes: PropTypes.string,
    needsToRepeat: PropTypes.bool,
    drillPlan: PropTypes.object, 
    division: PropTypes.object,
    company: PropTypes.object,
    workSite: PropTypes.object,
    status: PropTypes.object,
    drillTypeDetail: PropTypes.object,
    drillType: PropTypes.object,
    lightCondition: PropTypes.object,
    seaCondition: PropTypes.object,
    weatherCondition: PropTypes.object,
    drillEmergencyLevel: PropTypes.object,
    drillNotificationForm: PropTypes.object,
    drillReportPlannedWeeks: PropTypes.array,
    drillCheckListRequirementAnswers: PropTypes.array,
    attachments: PropTypes.array,
    people: PropTypes.array,
    unitsInvolved: PropTypes.array,
    timelines: PropTypes.array,
    participant: PropTypes.object,
    drillReportProjects: PropTypes.array,
    projects: PropTypes.array,
    referenceDate: PropTypes.instanceOf(Date),
    referenceYear: PropTypes.number,
    referenceMonth: PropTypes.number,
    idCompiler: PropTypes.string,
    idDataApprover: PropTypes.string,
    idDivisionManager: PropTypes.string,
    compiler: PropTypes.object,
    dataApprover: PropTypes.object,
    divisionManager: PropTypes.object,
  }).isRequired,
  editingDisabled: PropTypes.bool.isRequired,
  emergencylevel: PropTypes.arrayOf(PropTypes.object).isRequired,
  unitsInvolved: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DrillReportDetail;
